"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEditableBlockProps;

var _react = require("react");

var _useDeepCompare = require("use-deep-compare");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PROPS = {
  content: '',
  onContent: function onContent(content) {
    console.warn('EditableBlock.onContent() not provided:\n\n', content);
  },
  options: {
    editable: true
  },
  decorators: {}
};

function useEditableBlockProps(_ref) {
  var content = _ref.content,
      onContent = _ref.onContent,
      _decorators = _ref.decorators,
      _options = _ref.options;

  var _DEFAULT_PROPS$option = _objectSpread(_objectSpread({}, DEFAULT_PROPS.options), _options),
      returnHtml = _DEFAULT_PROPS$option.returnHtml,
      editable = _DEFAULT_PROPS$option.editable,
      preview = _DEFAULT_PROPS$option.preview;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      editIndex = _useState2[0],
      setEditIndex = _useState2[1];

  var __html = (0, _useDeepCompare.useDeepCompareMemo)(function () {
    var ___html = content;
    var decorators = !returnHtml ? _objectSpread({
      embededHtml: [/</g, "&lt;"]
    }, _decorators) : _objectSpread({
      spanPadding: [/<\/span>/g, "</span>\u200B"]
    }, _decorators);

    if (Object.keys(decorators).length > 0) {
      Object.keys(decorators).forEach(function (name) {
        var _decorators$name = _slicedToArray(decorators[name], 2),
            regex = _decorators$name[0],
            replacer = _decorators$name[1];

        ___html = ___html.replace(regex, replacer);
      });
    }

    ;
    return ___html;
  }, [content, returnHtml, _decorators, preview]);

  var save = (0, _useDeepCompare.useDeepCompareCallback)(function (element) {
    var _content;

    if (returnHtml) {
      _content = element.innerHTML.replaceAll("\u200B", '');
    } else {
      var div = document.createElement('div');
      div.innerHTML = element.innerHTML.replaceAll('<div', '\n<div');
      _content = div.textContent.replaceAll(/&lt;/g, '<');
    }

    ;

    if (content !== _content) {
      onContent(_content);
      setEditIndex(editIndex + 1);
    }

    ;
  }, [returnHtml, content, onContent, editIndex]);
  var onBlur = (0, _react.useCallback)(function (event) {
    save(event.target);
  }, [save]);
  var props = (0, _useDeepCompare.useDeepCompareMemo)(function () {
    return {
      editIndex: editIndex,
      contentEditable: editable,
      dangerouslySetInnerHTML: {
        __html: __html
      },
      suppressContentEditableWarning: true,
      save: save,
      onBlur: onBlur
    };
  }, [editable, __html, onBlur, editIndex]);
  return props;
}

;
useEditableBlockProps.propTypes = {
  /** Text to be edited whether file, section or block */
  content: _propTypes.default.string.isRequired,

  /** Function triggered on edit */
  onContent: _propTypes.default.func,

  /** Options for the editor */
  options: _propTypes.default.shape({
    /** Editable? */
    editable: _propTypes.default.bool,

    /** Return html instead of text */
    returnHtml: _propTypes.default.bool
  }),

  /** Object of replacers for html/css decoration of text */
  decorators: _propTypes.default.object,

  /** Callback triggered on Block click, provides block text and index. */
  onClick: _propTypes.default.func
};
useEditableBlockProps.defaultProps = DEFAULT_PROPS;